<template>
  <div class="d-flex flex-column bg-white pt-3 pb-3 border-bottom">
    <div class="container d-flex align-items-center justify-content-between px-0">
      <!-- Left Side -->
      <div class="d-flex align-items-center">
        <!-- Count Text -->
        <div class="font-weight-bold me-4 text-nowrap font-bold" style="font-size: 14px; color: #333;">
           <span class="d-block">現在スカウト希望をしている登録者</span>
           <span v-if="applicantsCount.total != 0">
             <template v-if="applicantsCount.total === 1">
               1名表示 / 全1名
             </template>
             <template v-else>
               {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 / 全{{ applicantsCount.total }}名
             </template>
           </span>
           <span v-else>0名表示 / 全0名</span>
        </div>

        <!-- Search Input -->
        <div class="position-relative me-2">
            <i class="fa fa-search position-absolute" style="top: 50%; left: 15px; transform: translateY(-50%); color: #000;"></i>
            <input
              type="text"
              class="form-control search-input"
              v-model="scoutJobTitle"
              @keyup.enter="applyFilters"
            />
        </div>

        <!-- Clear Search Button -->
        <button 
          v-if="hasActiveSearch"
          class="btn btn-clear-search me-2" 
          @click="clearSearch"
        >
          検索クリア
        </button>

        <!-- Job Search Button -->
        <button class="btn btn-search-job me-3" @click="applyFilters">
          求人検索
        </button>

         <!-- Bulk Action -->
         <b-dropdown
            id="actionDropdown"
            :text="selectedLabel"
            class="bulk-action-dropdown"
            @shown="$emit('shown')"
            @hidden="resetBulkAction"
            variant="light"
            no-caret
            :disabled="jobseekerIds.length === 0"
            :class="{ 'active-bulk-btn': jobseekerIds.length > 0 }"
          >
            <template #button-content>
              一括操作 <span style="font-size: 10px;">▼</span>
            </template>
            
            <!-- Status Update Submenu -->
            <li class="bulk-menu-item position-relative">
              <a href="#" class="dropdown-item d-flex justify-content-between align-items-center">
                ステータス一括更新
              </a>
              <div class="bulk-submenu" @click.stop>
                <div class="status-list p-2">
                  <div v-for="(status, index) in client_status_list" :key="index" class="form-check mb-2">
                    <input class="form-check-input" type="radio" :id="'bulk-status-'+index" :value="status" v-model="selectedBulkStatus">
                    <label class="form-check-label ms-1" :for="'bulk-status-'+index" style="white-space: nowrap; cursor: pointer;">
                      {{ status }}
                    </label>
                  </div>
                </div>
                <div class="text-center p-2 border-top">
                  <button class="btn btn-primary btn-sm btn-block bulk-operation-btn" @click="applyBulkStatus">OK</button>
                </div>
              </div>
            </li>

            <b-dropdown-item @click="showReviewListModal = true">
              リストに振分け
            </b-dropdown-item>
            
            <b-dropdown-item @click="openBulkMemoModal">メモ一括入力</b-dropdown-item>
            
            <!-- <b-dropdown-item @click="executeBulkAction('スカウト対象外にする')">
              スカウト対象外にする
            </b-dropdown-item> -->
          </b-dropdown>
      </div>

      <!-- Right Side -->
      <div class="d-flex align-items-center" style="padding-right: 30px;">
         <!-- Favorites Filter -->
         <div class="icon-button-wrapper me-5 pe-2">
             <div class="favorite-wrapper tooltip-container" @click="toggleFavorites">
               <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
             </div>
             <span class="icon-text-label">ブックマーク絞込</span>
         </div>

          <!-- Scout Filter -->
         <div class="icon-button-wrapper ms-3 me-2 pe-2">
              <div class="favorite-wrapper tooltip-container" @click="toggleScoutFilter">
                   <div class="scout-filter-circle" :class="{ active: scoutOnly }"></div>
              </div>
              <span class="icon-text-label">スカウト実施済<br>絞込</span>
         </div>
      </div>
    </div>
    <MessageTemplate ref="templateModal" />
    <ReviewListPopup
      ref="reviewListPopup"
      :showReviewListModal="showReviewListModal"
      :isBulkOperation="true"
      :jobseekerIds="jobseekerIds"
      @hideModal="hideReviewList"
    />
     <!-- Bulk Memo Modal -->
     <b-modal
       ref="bulkMemoModal"
       title="メモ一括入力"
       @ok.prevent="saveBulkMemo"
       cancel-title="キャンセル"
       ok-title="保存"
       :ok-disabled="loading"
     >
       <div class="d-block text-center">
        <b-form-textarea
          v-model="bulkMemoText"
          trim
          :rows="15"
          :max-rows="15"
        ></b-form-textarea>
       </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import MessageTemplate from '../contacts/MessageTemplate/MessageTemplate.vue';
import MessageTemplateModal from '../contacts/MessageTemplate/MessageTemplateModal.vue';
import FilterDropdown from './FilterDropdown.vue';
import ReviewListPopup from '@/components/dashboard/ReviewListPopup.vue';
import Favorite from '@/components/dashboard/applicants/Favorite.vue';

export default {
  name: 'ScoutApplicantsBar',
  components: {
    // SearchTemplateModal,
    // Csv,
    MessageTemplateModal,
    MessageTemplate,
    FilterDropdown,
    ReviewListPopup,
    Favorite
  },
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      title: '',
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
      isSubmitting: false,
      selectedLabel: '▼ 一括操作',
      showMessageTemplateModal: false,
      clientUsers: [],
      selectedUserId: null,
      scoutJobTitle: '',
      // isFavoritesOnly: false,
      // isScoutOnly: false,
      bulkActionType: null,
      selectedBulkStatus: null,
      bulkMemoText: '',
      showReviewListModal: false,
    };
  },
  computed: {
    ...mapState({
      checkAllState: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      loading: ({ applicant }) => applicant.loading,
      client_status_list: ({ applicant }) => applicant.client_status,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      scoutOnly: ({ applicant }) => applicant.scoutOnly,
      searchParams: ({ applicant }) => applicant.scoutSearchParams,
    }),
    isCheckAll: {
      get() {
        return this.checkAllState; // Get value from Vuex state
      },
      set(value) {
        this.setCheckAll(value); // Trigger mutation when value changes
      },
    },
    scoutedBy: {
      get() {
        return this.getScoutedBy; // Get value from Vuex state
      },
      set(value) {
        this.setScoutedBy(value); // Trigger mutation when value changes
      },
    },
    ...mapGetters({
      applicantsCount: 'getApplicantCounts',
      isReviewer: 'isCreateReviewUser',
      // users: 'getAllUsers',
      assignedUsers: 'getAllAssignedUsers',
      getScoutedBy: 'getScoutedBy',
    }),
    checkSelectedLabel() {
      return this.selectedLabel === '一括操作　　▼';
    },
    hasActiveSearch() {
      return this.scoutJobTitle !== '' || this.scoutOnly;
    },
  },
  methods: {
    ...mapMutations([
      'setCheckAll',
      'setLoading',
      'mutateApplicantsAfterMultipleStatus',
      'setJobseekerIds',
      'setReloadApplicants',
      // 'setSearchParams',
      'setScoutedBy',
      // mutations.applicant.TOGGLE_FAVORITES,
    ]),
    ...mapActions({
      // loadAllUsers: 'loadAllUsers',
      loadAssingedUsers: 'loadAssingedUsers'
    }),
    showScoutTemplate() {
      this.$refs.templateModal.show();
      // this.showMessageTemplateModal = true;
    },
    hideScoutTemplate() {
      this.showMessageTemplateModal = false;
    },
    checkAll() {
      if (this.isCheckAll) {
        this.setCheckAll(true);
      } else {
        this.setCheckAll(false);
      }
    },
    executeBulkAction(action) {
      this.selectedLabel = action;
      if (action === 'スカウト対象外にする') {
        this.removeFromScout();
      }
    },
    handleUserFilterApply(selectedUserId) {
      if (selectedUserId) {
        // Set searchParams in Vuex store for scoutedBy filter
        this.setScoutedBy(selectedUserId);
      }
    },
    handleUserFilterHidden() {
      // Handle when dropdown is hidden
      // console.log('User filter dropdown hidden');
    },
    clearFilters() {
      // Clear searchParams including scoutedBy filter
      this.setScoutedBy(null);
      // Reset the FilterDropdown component
      if (this.$refs.userFilterDropdown) {
        this.$refs.userFilterDropdown.selectedUserId = null;
      }
    },
    removeFromScout() {
      this.errors = [];

      if (this.jobseekerIds.length == 0) {
        return;
      } else {
        // this.loading = true;
        this.setLoading(true);
        // this.loading = true;
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: '未確認',
        })
          .then(({ data }) => {
            // console.log(data.data)
            // this.mutateApplicantsAfterMultipleStatus(data.data);
            this.setCheckAll(false);
            this.setReloadApplicants(true);
            // this.loading = false;
          })
          .catch((error) => console.log(error))
          .then(() => {
            // this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
            // this.loading = false;
            // this.setLoading(false);
          });
      }
    },
    toggleFavorites() {
       this.$store.commit(mutations.applicant.TOGGLE_FAVORITES, !this.favoritesOnly);
    },
    toggleScoutFilter() {
        this.$store.commit(mutations.applicant.TOGGLE_SCOUT, !this.scoutOnly);
    },
    clearSearch() {
      this.scoutJobTitle = '';
      this.$store.commit(mutations.applicant.TOGGLE_SCOUT, false);
      this.$store.commit('setScoutSearchParams', {});
    },
    applyFilters() {
      const params = { ...this.searchParams };

      if (this.scoutJobTitle) {
        params.jobTitle = this.scoutJobTitle;
      } else {
        delete params.jobTitle;
      }

      this.$store.commit('setScoutSearchParams', params);
    },
    resetBulkAction() {
      this.bulkActionType = null;
      this.selectedBulkStatus = null;
    },
    applyBulkStatus() {
      if (this.selectedBulkStatus) {
        this.changeStatus(this.selectedBulkStatus);
      }
    },
    openBulkMemoModal() {
      this.bulkMemoText = '';
      this.$refs.bulkMemoModal.show();
    },
    saveBulkMemo() {
      if (this.loading || this.jobseekerIds.length == 0 || !this.bulkMemoText.trim()) {
        return;
      }
      
      this.setLoading(true);
      ApiService.put(Api.endpoints.MULTIPLE_MEMO, {
        jobseekerIds: this.jobseekerIds,
        memo: this.bulkMemoText
      })
      .then(({ data }) => {
        this.setReloadApplicants(true);
        this.bulkMemoText = '';
        this.$refs.bulkMemoModal.hide();
        this.setCheckAll(false);
        this.setJobseekerIds([]);
        this.resetBulkAction();
      })
      .catch(({ response }) => {
        console.error(response);
      })
      .finally(() => {
        // this.setLoading(false);
      });
    },
    changeStatus(status) {
      if (this.jobseekerIds.length == 0) {
        return;
      }
      this.setLoading(true);
      ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
        jobseekerIDs: this.jobseekerIds,
        status: status,
        isNewPanel: true
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterMultipleStatus(data.data);
          this.setReloadApplicants(true);
        })
        .catch(({ response }) => {
           console.log(response);
        })
        .then(() => {
          this.setJobseekerIds([]);
          this.setCheckAll(false);
          this.resetBulkAction();
          // this.setLoading(false);
        });
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
  },
  mounted() {
    // this.loadAllUsers();
    this.loadAssingedUsers();
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },
  },
};
</script>
<style scoped>
.bulk-operation-btn {
  border-color: rgb(98, 164, 253);
  background: rgb(98, 164, 253);
  min-width: 60px !important;
  width: 20px;
  margin: auto;
}
.search-input {
  /* border-radius: 20px; */
  width: 250px;
  border: 1px solid #b3b3b3;
  border-radius: 4px;
  height: 38px;
  font-size: 14px;
  background-color: transparent;
  padding-left: 40px;
}

.search-input::placeholder {
  color: #ccc;
}

.btn-search-job {
  background-color: #00C4B4;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  padding: 5px;
  height: 30px;
  width: 80px;
  min-width: 80px;
  font-size: 14px;
}
.btn-search-job:hover {
  background-color: #00a89a;
  color: white;
}

.btn-clear-search {
  width: 120px;
  height: 30px;
  background-color: #E5E7EB;
  border: 1px solid #ccc; /* Assuming standard border color since only width was specified */
  border-radius: 4px;
  color: #333;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

/* Deep selector for bootstrap dropdown button styling */
.bulk-action-dropdown >>> .btn-light {
    background-color: #e0e0e0;
    border: none;
    color: #333;
    border-radius: 4px;
    height: 38px;
    display: flex;
    align-items: center;
    width: 135px;
    min-width: 135px;
    height: 30px;
    font-weight: bold;
    font-size: 13px;
}

.scout-filter-circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: background-color 0.3s;
}
.scout-filter-circle.active {
    background-color: #009D9E; /* Green color */
    border-color: #009D9E;
}

.active-bulk-btn >>> .btn-light {
  background-color: #5d7593 !important;
  color: white !important;
  border-color: #5d7593 !important;
}

.bulk-menu-item:hover .bulk-submenu {
  display: block;
}

.bulk-submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  width: 200px;
  background: white;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
}

.icon-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  min-width: 90px;
}

.icon-button-wrapper .favorite-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 30px;
  margin-bottom: 2px;
}

.icon-text-label {
  font-size: 11px;
  color: #000000;
  text-align: center;
  line-height: 1.2;
  font-weight: 700;
  display: block;
}
</style>
